import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'minuteToHour'})
export class MinuteToHourPipe implements PipeTransform {
  minute: string[] = ['120', '150', '180', '210', '240', '270', '300', '330', '360'];
  hour: string[] = ['2시간', '2시간 30분', '3시간', '3시간 30분', '4시간', '4시간 30분', '5시간', '5시간 30분', '6시간'];

  transform(value: string): any {
    return this.hour[this.minute.indexOf(value)];
  }
}


// WEBPACK FOOTER //
// ./src/app/pipe/minuteToHour.pipe.ts